import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";

import AppIcon from "components/app-icon";
import classNames from "common/class-names";
import checkerIcon from "assets/images/components/app-checkbox/checker-icon.svg";

const AppCheckbox = (props) => {
	const activated = useMemo(() => props.value, [props.value]);
	const error = useMemo(() => props.error && props.touched, [props.error, props.touched]);

	const className = useMemo(() => {
		return classNames({
			"app-checkbox": true,
			"app-checkbox--error": error,
			"app-checkbox--active": activated,
			...(props.className && {
				[props.className]: true,
			}),
		});
	}, [props.className, error, activated]);

	return (
		<button className={className} type="button" name={props.name} disabled={props.disabled} value={activated || ""} onClick={props.onClick}>
			<div className="app-checkbox__box">
				{props.unCheckIcon && !activated && <div className="app-checkbox__uncheck-icon" />}
				{activated && <AppIcon src={checkerIcon} />}
			</div>

			<p className="app-checkbox__label">{props.label}</p>
		</button>
	);
};

AppCheckbox.propTypes = {
	value: PropTypes.bool,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	name: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default memo(AppCheckbox);
